import { useState, useEffect } from "react";
import { emiService } from "../services/emiService";

export const useEMICalculator = () => {
  const [loanAmount, setLoanAmount] = useState("");
  const [years, setYears] = useState("");
  const [emiData, setEmiData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Utility: number → formatted string
  const numberToWords = (num) => {
    if (!num || num <= 0) return "";
    return num.toLocaleString("en-IN");
  };

  useEffect(() => {
    // Only calculate if both inputs are valid numbers > 0
    const loan = Number(loanAmount);
    const tenure = Number(years);

    if (!loan || !tenure || loan <= 0 || tenure <= 0) {
      setEmiData(null);
      return;
    }

    let active = true;
    setLoading(true);

    (async () => {
      // Use 6% interest explicitly
      const res = await emiService.calculateEMI(loan, tenure, 6);

      if (active) {
        if (res.success) setEmiData(res.data);
        else setEmiData(null);

        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [loanAmount, years]);

  // Sanitized setters to prevent negative values
  const safeSetLoanAmount = (val) => setLoanAmount(val >= 0 ? val : 0);
  const safeSetYears = (val) => setYears(val >= 0 ? val : 0);

  return {
    loanAmount,
    setLoanAmount: safeSetLoanAmount,
    years,
    setYears: safeSetYears,
    emiData,
    loading,
    numberToWords
  };
};
